import { render, staticRenderFns } from "./small-ico.vue?vue&type=template&id=cee9b83c&scoped=true&"
import script from "./small-ico.vue?vue&type=script&lang=js&"
export * from "./small-ico.vue?vue&type=script&lang=js&"
import style0 from "./small-ico.vue?vue&type=style&index=0&id=cee9b83c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee9b83c",
  null
  
)

export default component.exports